import Icon from '../components/Icon.vue'

Icon.register({
  baby: {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M192 160C236.2 160 272 124.2 272 80S236.2 0 192 0 112 35.8 112 80 147.8 160 192 160zM138.6 408.8L164.2 376.8 102.7 325.6 56.8 383C45.4 397.2 45.1 417.4 56 432L104 496C111.9 506.5 123.9 512 136 512 144.3 512 152.8 509.4 160 504 177.7 490.8 181.2 465.7 168 448L138.6 408.8zM281.3 325.6L219.8 376.8 245.4 408.8 216 448C202.8 465.7 206.3 490.8 224 504 231.2 509.4 239.6 512 248 512 260.2 512 272.2 506.5 280 496L328 432C338.9 417.4 338.6 397.2 327.2 383L281.3 325.6zM376.7 145C364 126.9 339.1 122.6 321 135.2L280.4 163.7C227.7 200.7 156.2 200.7 103.6 163.7L63 135.3C44.9 122.6 20 127 7.3 145-5.4 163.1-1 188 17 200.7L57.6 229.2C74.6 241.1 93 250.1 112 257.1V288H272V257.2C291 250.2 309.4 241.2 326.4 229.3L367 200.8C385.1 188 389.4 163.1 376.7 145z'
      }
    ]
  }
})
